import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { setting } from "../Config/Config";
import JSONData from "../data/data.json";
function Label(props) {
  const [slogan, setSlogan] = useState();
  useEffect(() => {
    setSlogan(JSONData.Header.slogan);
  }, []);
  return (
    <div
      style={{
        width: "100%",
        height: 30,
        alignItems: "center",
      }}
    >
      <marquee>
        <p
          style={{
            color: setting.orange,
            fontSize: 20,
            fontFamily: "audiowide",
          }}
        >
          {slogan}
        </p>
      </marquee>
    </div>
  );
}

export default Label;
